//
// ImageFieldOptions
//
// Field options for type 'image'

import { observer } from 'mobx-react-lite'

import { FolderFieldOption } from './FolderFieldOption'

export const ImageFieldOptions = observer(function ImageFieldOptions({
    field,
    selectModified,
    worksheet,
    onAction,
    setSelected,
    renderkeyprefix,
}) {
    if (!field) return null

    return (
        <>
            <FolderFieldOption
                field={field}
                selectModified={selectModified}
                worksheet={worksheet}
                onAction={onAction}
                setSelected={setSelected}
                renderkeyprefix={renderkeyprefix}
            />
        </>
    )
})
